import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PageWithSidebar from 'components/PageWithSidebar';
import NotFound from 'components/NotFound';
import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import HotelSidebar from 'components/HotelSidebar';
import HotelEditTabs from 'components/HotelEditTabs';

import { withData } from 'lib';
import { HotelEditPageQuery } from '__generated__/HotelEditPageQuery.graphql';

const query = graphql`
  query HotelEditPageQuery(
    $id: ID!
    $first: Int!
    $after: String
    $search: String
    $sort: RoomSorting
  ) {
    hotel(id: $id) {
      name

      ...HotelEditTabs_hotel
      ...HotelSidebar_hotel
    }

    ...HotelEditTabs_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<HotelEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/hotels', name: 'Viešbučiai' }];

const HotelEditPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<HotelEditPageQuery>(query, preloadedQuery);
  const { hotel } = data;

  if (!hotel) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<HotelSidebar hotel={hotel} />}
      breadcrumbs={[...breadcrumbs, { name: hotel.name }]}>
      <HotelEditTabs hotel={hotel} data={data} />
    </PageWithSidebar>
  );
};

export default withData<HotelEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton tabs={4} breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams, currentUser }) => ({
    id: routeParams.id,
    first: currentUser.itemsPerPage,
  }),
})(HotelEditPage);
